const PipsTradeAppContentFour = () => {
  return (
    <div className="how__work__platform">
      <div className="container">
        <div className="row">
          <div className="col-lg-6 col-md-12 col-sm-12 col-12">
            <div className="thumb-left">
              <div className="content-left">
                <h2>Markets at Your Fingertips</h2>

                <p>
                  Currency prices fluctuate based on economic data, interest
                  rate changes, and global market sentiment. At The Pips,
                  traders benefit from real-time data feeds, analytical tools,
                  and reliable charting systems to stay ahead of trends.
                </p>
              </div>
              <img
                src={process.env.PUBLIC_URL + "/images/platforms/pips_trade_app/trade_app_3.png"}
                alt="computer images"
              />
            </div>
          </div>
          <div className="col-lg-6 col-md-12 col-sm-12 col-12 sm__mt--40 md__mt--40">
            <div className="content-right">
              <h3>Forex</h3>
              <p>
                Access tight spreads, rapid execution, and over 60+ currency
                pairs. Ideal for traders seeking liquidity and volatility.
                {/* Conversely, rate cuts can weaken a
                currency as investors seek higher yields elsewhere. Traders
                closely follow central bank announcements and policy statements
                to anticipate shifts in monetary policy. */}
              </p>
              <hr className="black-line" />
              <h3> Commodities</h3>
              <p>
                Trade gold, silver, oil, and more with real-time pricing and
                dynamic leverage options. Diversify your strategy with global
                assets
                {/* Stable inflation and strong
                performance usually strengthen a currency, while economic
                slowdown or uncertainty can cause depreciation. Traders monitor
                key indicators like CPI, PMI, and retail sales to identify
                potential trends in currency valuation. */}
              </p>
              <hr className="black-line" />
              <h3>Stocks</h3>
              <p>
                Buy and sell shares of the world’s most recognized companies.
                Analyze performance, track indices, and make informed investment
                decisions.
                {/* In contrast, geopolitical
                tensions or unexpected global events can increase volatility as
                traders move toward safe-haven assets like the USD, CHF, or JPY. */}
              </p>
              <hr className="black-line" />
              <h3>Cryptocurrencies</h3>
              <p>
                Engage in digital trading with top-performing cryptocurrencies.
                Trade with high security and fast execution backed by The Pips’
                robust network.
                {/* Large institutional players and algorithmic trading
                systems can amplify these effects, making sentiment analysis a
                valuable tool for modern forex traders. */}
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PipsTradeAppContentFour;
